import axios from "../axios";

const getWithdrawTransactions = async function (accessToken,params = {}) {
    try {
        const response = await axios.post('admin/withdraw-transaction/getWithdrawTransactions', params,{
            headers: {
                'Authorization': accessToken
            }
        });
        return response.data;
    }
    catch (e) {
        return {
            success: false,
            errorCode: e.response.status
        }
    }
}

export default getWithdrawTransactions;
